/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * CreatorBase
 * auto generated base class for the model CreatorModel.
 */
export const CreatorModelBase = ModelBase.named('Creator')
  .props({
    __typename: types.optional(types.literal('Creator'), 'Creator'),
    id: types.union(types.undefined, types.string),
    name: types.union(types.undefined, types.string)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CreatorModelSelector extends QueryBuilder {
  get id() {
    return this.__attr('id')
  }
  get name() {
    return this.__attr('name')
  }
}
export function selectFromCreator() {
  return new CreatorModelSelector()
}

export const creatorModelPrimitives = selectFromCreator().name
